import { PageEvent } from '@noths/polaris-client-next-components';
import { _Omit } from '@noths/polaris-dev-ts-recipes';

import { PageProps, ProductFieldObject } from 'src/types';
import { generateProductFieldObject } from './googleAnalytics';

export type PageEcommerceObject = _Omit<ProductFieldObject, 'quantity'>;

export interface PageEventObject extends PageEvent {
  ecommerce: {
    detail: { products: PageEcommerceObject[] };
  };
}

export const getServerSidePageEventObject = (
  pageProps: PageProps,
  version: string,
  appVersion: string,
) => {
  if (!pageProps?.updatedReduxState) {
    return {} as PageEventObject;
  }

  const { product, personalisation, deliveryZoneOptions } = pageProps.updatedReduxState;

  const { quantity, ...productEcommerce }: ProductFieldObject = {
    ...generateProductFieldObject({
      product,
      personalisation,
      deliveryZoneOptions,
    }),
    dimension92: String(product.options.length),
  };

  const pageEventObject: PageEventObject = {
    page: {
      category: 'Product',
      environment: process.env.NODE_ENV,
      react: 'true',
      app_version: appVersion,
      release_version: version,
    },
    ecommerce: {
      detail: {
        products: [productEcommerce],
      },
    },
  };

  return pageEventObject;
};
